import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ExternalLinkIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 14V17.5C20 18.881 18.881 20 17.5 20H6.5C5.119 20 4 18.881 4 17.5V6.5C4 5.119 5.119 4 6.5 4H10M7.927 16L19.927 4M19.927 9V4H14.927"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ExternalLinkIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ExternalLinkIcon);
